import React, { useState, useEffect } from "react";
import {
  Grid,
  TextField,
  Button,
  Box,
  Typography,
  TextareaAutosize,
} from "@mui/material";
import ScrollReveal from "scrollreveal";
import ReCAPTCHA from "react-google-recaptcha";

const ContactUs = () => {
  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [captchaVerified, setCaptchaVerified] = useState(false);

  useEffect(() => {
    ScrollReveal().reveal(".reveal-left", {
      duration: 2000, // Animation duration (in ms)
      distance: "100px", // Distance the element moves
      origin: "left", // Animation starts from the left
      easing: "ease-in-out", // Easing function
    });

    ScrollReveal().reveal(".reveal", {
      duration: 2000, // Animation duration (in ms)
      distance: "100px", // Distance the element moves
      origin: "bottom", // Animation starts from the left
      easing: "ease-in-out", // Easing function
    });
  }, []);

  // Function to handle form submission
  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent default form submission
    if (captchaVerified) {
      // Proceed with form submission or API call
      console.log("Form submitted successfully!"+formValues);
    } else {
      alert("Please complete the CAPTCHA first!");
    }
    console.log(formValues);
  };

  // Function to handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  // Handle the reCAPTCHA response
  const onCaptchaChange = (value) => {
    setCaptchaVerified(true); // Mark as verified when the captcha passes
  };

  return (
    <Box
      className="container-sm"
      sx={{ flexGrow: 1, padding: "20px", minHeight: "100vh", mt: 5 }}
    >
      <Grid container spacing={3}>
        {/* Left Container (Google Map, Header, and Paragraph) */}
        <Grid item xs={12} md={6} className="reveal-left">
          <Typography variant="h5" gutterBottom style={{ color: "#495057" }}>
            Sastraprakasika Trust
          </Typography>
          <Typography variant="body1" gutterBottom style={{ color: "#495057" }}>
            142, Santhome High Road, Raja Annamalaipuram, Chennai – 600028.
          </Typography>

          {/* Google Map Embed */}
          <Box
            sx={{
              position: "relative",
              paddingBottom: "56.25%", // Maintain aspect ratio (16:9)
              height: 0,
              overflow: "hidden",
              backgroundColor: "#fff",
              marginBottom: "16px",
              borderRadius: "4px",
            }}
          >
            <iframe
              src="https://maps.google.com/maps?q=142,%20Santhome%20High%20Road,%20Raja%20Annamalaipuram,%20%20Chennai%20%E2%80%93%20600028.&amp;t=&amp;z=13&amp;ie=UTF8&amp;iwloc=&amp;output=embed"
              frameBorder="0"
              scrolling="no"
              width="100%"
              height="100%"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
              }}
              allowFullScreen
            />
          </Box>
        </Grid>

        {/* Right Container (Form) */}
        <Grid className="" item xs={12} md={6}>
          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <Typography variant="h5" gutterBottom style={{ color: "#495057" }}>
              Get in Touch with Us
            </Typography>
            <TextField
              required
              label="Your Name"
              name="name"
              variant="outlined"
              margin="normal"
              value={formValues.name}
              onChange={handleInputChange}
              fullWidth
              sx={{
                maxWidth: "400px", // Max width to 400px
                width: "90%", // Responsive width
              }}
            />
            <br />
            <TextField
              required
              label="Your Email"
              name="email"
              type="email"
              variant="outlined"
              margin="normal"
              value={formValues.email}
              onChange={handleInputChange}
              fullWidth
              sx={{
                maxWidth: "400px", // Max width to 400px
                width: "90%", // Responsive width
              }}
            />
            <br />
            <TextField
              label="Subject"
              name="subject"
              variant="outlined"
              margin="normal"
              value={formValues.subject}
              onChange={handleInputChange}
              fullWidth
              sx={{
                maxWidth: "400px", // Max width to 400px
                width: "90%", // Responsive width
              }}
            />
            <br />
            <TextareaAutosize
              minRows={8}
              placeholder="Your Message"
              name="message"
              style={{
                width: "85%", // Responsive width
                maxWidth: "400px", // Max width to 400px
                padding: "10px",
                marginTop: "16px",
                borderRadius: "4px",
                borderColor: "#ccc",
                resize: "none", // Disable resizing
              }}
              value={formValues.message}
              onChange={handleInputChange}
            />
            <br />
            {/* reCAPTCHA component */}
            <Box>
              <ReCAPTCHA
                sitekey="6LelA0oqAAAAAC_4OeGzjS6pmnNe1wk5geRQJquJ" // Use your site key here
                onChange={onCaptchaChange} // This function is triggered when the user completes the CAPTCHA
              />
            </Box>

            <br />
            <Button
              variant="contained"
              color="primary"
              type="submit"
              sx={{ marginTop: "20px", maxWidth: "80%" }} // Button aligned with input width
            >
              Send Message
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ContactUs;
